import axios, {
  type AxiosResponse,
  type AxiosError,
  type AxiosInstance,
} from "axios";

export async function error(
  this: AxiosInstance,
  error: AxiosError,
): Promise<AxiosResponse> {
  const response = error.response;
  if (!response || response.status !== 504 || response.config.doNotRetry) {
    throw error;
  }
  return (this ?? axios).request({
    ...(response.config.originalConfig ?? response.config),
    originalConfig: response.config.originalConfig,
    doNotRetry: true,
  });
}

export const gatewayTimeout = {
  error,
};
